import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Card } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { List } from "immutable";
import CompanyService from "./../services/company-los-services";
import { ORDERING_WAYS } from "../constants/enums";

const SECTIONS = new OrderedMap({
    // 1: {
    //     type: "DIVIDER",
    //     label: "Details"
    // },
    2: {
        type: "DIVIDER",
        label: "About the Distributor"
    },
    3: {
        type: "DIVIDER",
        label: "Trade Terms"
    },
    4: {
        type: "DIVIDER",
        label: "Manpower"
    },
    5: {
        type: "DIVIDER",
        label: "Ordering"
    },
    6: {
        type: "DIVIDER",
        label: "Dependence"
    },
    7: {
        type: "DIVIDER",
        label: "Others"
    }
});

const getFormFields = ({
    allFieldsDisabled
}) => new OrderedMap({
    // corporate_relationship_manager: {
    //     label: "Progcap RM",
    //     type: INPUT_TYPES.SELECT,
    //     mode: "multiple",
    //     className: "form-field fb-30 w-33 mr-3perc",
    //     disabled: allFieldsDisabled,
    //     category: 1
    // },
    establishment_year: {
        label: "Establishment Year",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 2
        // //rules: [YEAR_NOT_GREATER_THAN_CURRENT_RULE]
    },
    location: {
        label: "Location",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        onSearch: str => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["state_name"]: str
                }).then(({ data }) => ({
                    data: new List(data)
                        .toMap()
                        .mapKeys((k, _) => _.name)
                        .toList()
                        .toArray()
                }))
                : Promise.resolve({
                    data: []
                });
        },
        category: 2
    },
    headquarter: {
        label: "HeadQuarter",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        onSearch: str => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["district_name"]: str
                }).then(({ data }) => ({
                    data: new List(data)
                        .toMap()
                        .mapKeys((k, _) => _.name)
                        .toList()
                        .toArray()
                }))
                : Promise.resolve({
                    data: []
                });
        },
        category: 2
    },
    total_no_of_dealers: {
        label: "Total Dealers",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 2,
        // //rules: [POSITIVE_INTEGER_RULES]
    },
    dealers_with_regular_billing: {
        label: "Dealers with regular Billing",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 2
        //rules: [POSITIVE_INTEGER_RULES]
    },
    territory_managed: {
        label: "Territory Managed by Distributor",
        type: INPUT_TYPES.TEXTAREA,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 2
    },
    // program_anchor: {
    //     label: "Program Anchor",
    //     type: INPUT_TYPES.OBJECT_SELECT,
    //     className: "form-field fb-30 w-33 mr-3perc",
    //     disabled: allFieldsDisabled,
    //     category: 2,
    //     showSearch: true,
    //     labelProp: "name",
    //     onSearch: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.Anchor, str)
    // },
    current_market_os: {
        label: "Current Market Outstanding(INR)",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 3
        // //rules: [POSITIVE_INTEGER_RULES]
    },
    credit_days: {
        label: "Credit Period for Dealers",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 3
        // //rules: [{ ...POSITIVE_INTEGER_RULES }]
    },
    manpower: {
        label: "Total Number of Manpower employed by Distributor",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 4
        // //rules: [POSITIVE_INTEGER_RULES]
    },
    ordering_ways: {
        type: INPUT_TYPES.SELECT,
        label: "How is the order taken from the dealer (software/ app / on call / via SMS / over whatsapp/ by your sales person)?",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        mode: "multiple",
        options: ORDERING_WAYS.map((value, label) => ({ value: value, label })).toList().toArray(),
        category: 5
    },
    average_dealer_lor_in_months: {
        type: INPUT_TYPES.NUMBER,
        label: "How long have your average dealers been working with you ?",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 6
        //rules: [MONTH_RULES]
    },
    average_dealer_sales_contribution: {
        type: INPUT_TYPES.NUMBER,
        label: "What portion of their sales does your company contribute ?",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 6
        //rules: [PERCENTAGE_RULES]
    },
    future_plan: {
        type: INPUT_TYPES.TEXTAREA,
        label: "Future plans of the distributor (E.g. geographical expansion, brand portfolio extension etc.)",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7
    },
    other_info: {
        type: INPUT_TYPES.TEXTAREA,
        label: "Any other information about the distributor",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7
    },
    remarks_progcap_rm: {
        type: INPUT_TYPES.TEXTAREA,
        label: "Remarks for Progcap RM",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7
    },
    profile: {
        type: INPUT_TYPES.TEXTAREA,
        label: "Profile",
        className: "form-field fb-100 w-100 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7,
    },
    credit_remarks: {
        type: INPUT_TYPES.TEXTAREA,
        label: "Credit Remarks",
        className:"form-field fb-100 w-100 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7
    },
    program_size: {
        type: INPUT_TYPES.FLOAT,
        label: "Program Size",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7,
    },
    dealer_profile_turnover_from: {
        type: INPUT_TYPES.FLOAT,
        label: "Dealer Profile Turnover from",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7,
    },
    dealer_profile_turnover_to: {
        type: INPUT_TYPES.FLOAT,
        label: "Dealer Profile Turnover to",
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        category: 7,
    }
    
});


class CompanyDetailsForm extends React.Component {
    state = {
        sales_manager_users: null
    };


    componentDidMount() {
        CompanyService.getSMList().then(({ data }) => {
            this.setState({
                sales_manager_users: data
            });
        });
    }

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    const newValues = {
                        ...values,
                        anchor: values.anchor && values.anchor.id,
                        location: values.location && values.location.id,
                        date: values.date && values.date.format("YYYY-MM-DD"),
                        headquarter: values.headquarter && values.headquarter.id,
                        // program_anchor: values.program_anchor && values.program_anchor.id,
                        anchor_yoa: values.anchor_yoa && +(values.anchor_yoa.format("YYYY"))
                    };
                    this.props.onValuesSubmit(newValues);
                }
            });
        }
    }

    onSearchAnchor = (val) => {
        return CompanyService.getCompanyLosProfiles({
            page: 1,
            page_size: 20,
            search: val,
            type: 1
        }).then(({ data }) => {
            return {
                data: data && data.results
            };
        });
    }

    render() {
        return (<Form onSubmit={this.onValuesSubmit}>
            <div className={"form-row align-items-center"}>
                {this.formFields.groupBy(_ => _.category)
                    .map((_, category) => {
                        return (
                            <div key={category} className={"w-100 pt-10"}>
                                <h3 className={"pt-5 pb-5"}>{SECTIONS.find((section, k) =>  k == category).label}</h3>
                                <Card className={"no-shadow border-none"}>
                                    <div className={"d-flex flex-row align-items-center flex-wrap w-100"}>
                                        {_.map((field, fieldName) => {
                                            // if (field.type === "DIVIDER") {
                                            //     return (<Divider key={fieldName} orientation="left">{" "}{field.label}{" "}</Divider>);
                                            // }
                                            field.disabled = this.props.disabledFields;
                                            if (fieldName === "anchor") {
                                                field.onSearch = this.onSearchAnchor;
                                            }
                                            if (fieldName === "anchor_asm") {
                                                field.options = this.props.applicants && this.props.applicants.map((_) => ({
                                                    label: _.first_name + " " + _.last_name,
                                                    value: _.id
                                                }));
                                            }
                                            if (fieldName === "corporate_relationship_manager") {
                                                field.options = this.state.sales_manager_users && this.state.sales_manager_users.length ? new List(this.state.sales_manager_users.map((_) => ({
                                                    label: _.full_name,
                                                    value: _.id
                                                }))) : new List([]);
                                            }
                                            return this.fieldGenerator(
                                                fieldName,
                                                field,
                                                this.getValidateStatus(fieldName)
                                            )();
                                        }).toList()}
                                    </div>
                                </Card>
                            </div>
                        );
                    }).toList()
                }
            </div>
            {!this.props.disabledFields ? (
                <div className={"form-row flex-row-reverse pt-10 pb-10"}>
                    <Button type={"primary"} htmlType={"submit"}>
                        {this.props.loading ? <Icon type={"loading"} /> : null}
                        Update
                    </Button>
                </div>
            ) : null}
        </Form>);
    }
}

CompanyDetailsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    applicants: PropTypes.object,
    disabledFields: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        if(values) {
            return new Map(values).map((value, key) => {
                if(key === "corporate_relationship_manager") {
                    return Form.createFormField({
                        value: value && value.map(_ => _.id)
                    });
                }
                return Form.createFormField({
                    value
                });
            }).toJS();
        }
    }
})(CompanyDetailsForm);